import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SweetAlertHelper } from '../../../core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-add-zip-code',
  templateUrl: 'add-zip-code.component.html',
  styleUrls: ['./add-zip-code.component.scss'],
})

export class AddZipCodeComponent implements OnInit, OnChanges {
  @Output() emitZipcode: EventEmitter<any> = new EventEmitter<any>();
  @Input() countyzipcodes: any[] = [];
  @Input() modalAddZip: any;
  dataArray: any = [];
  zipcode: number;

  constructor(private sweetAlert: SweetAlertHelper) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countyzipcodes'] && this.countyzipcodes) {
      this.dataArray = this.countyzipcodes;
    }
  }

  ngOnInit() {}

  addZipCode() {
    if (this.zipcode) {
      const match = this.dataArray.filter(
        (z: any) => String(z.zipcode) === String(this.zipcode)
      );
      if (match.length > 0) {
        this.sweetAlert.createCustomAlert({
          title: 'Error',
          text: `Zip code ${this.zipcode} is already added`,
          type: 'error',
        });
      } else {
        this.emitZipcode.emit(this.zipcode);
        this.cancel();
      }
    }
  }

  cancel() {
    this.modalAddZip.close();
  }

  get disabledBtn(): boolean {
    return String(this.zipcode).length === 5;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/county/add-zip-code/add-zip-code.component.ts